import { APP_INITIALIZER, FactoryProvider } from '@angular/core';

import { Observable, take } from 'rxjs';

import { EnvironmentService } from '@hdms/shared/util-core';

import { CurrencyService } from './currency.service';

export function initializeCurrency(
  currencyService: CurrencyService,
  envService: EnvironmentService
): () => Observable<unknown> {
  return () => (envService.isStandalone || envService.hostContext) && currencyService.getConfig$().pipe(take(1));
}

export const CURRENCY_PROVIDER: FactoryProvider = {
  provide: APP_INITIALIZER,
  useFactory: initializeCurrency,
  deps: [CurrencyService, EnvironmentService],
  multi: true
};
